(() => {
  document.querySelectorAll('[data-address-edit]').forEach((button) => {
    button.addEventListener('click', () => {
      const id = button.getAttribute('data-address-edit')
      const card = button.closest('[data-address-card]')
      const editor = card?.querySelector(`[data-address-editor="${id}"]`)
      const view = card?.querySelector('.account-address__view')
      if (editor) editor.hidden = false
      if (view) view.hidden = true
    })
  })

  document.querySelectorAll('[data-address-cancel]').forEach((button) => {
    button.addEventListener('click', () => {
      const card = button.closest('[data-address-card]')
      const editor = card?.querySelector('[data-address-editor]')
      const view = card?.querySelector('.account-address__view')
      if (editor) editor.hidden = true
      if (view) view.hidden = false
    })
  })
})()
